import { useNavigate } from 'react-router-dom';
import { newsData } from '@/lib/utils/news-data';
import { useTranslation } from 'react-i18next';

export default function NewsIndex() {
    const { t } = useTranslation();
    const navigate = useNavigate();

    const formatNewsDate = (epochSeconds) => {
        if (!epochSeconds) return '';
        try {
            return new Date(Number(epochSeconds) * 1000).toLocaleDateString('fr-FR');
        } catch {
            return '';
        }
    };

    return (
        <div className="p-8 space-y-6">
            <div className="flex items-center justify-between">
                <h1 className="text-xl font-bold text-foreground">{t('dashboard:actualitesGuides')}</h1>
            </div>

            <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-4 gap-4">
                {newsData.map((item, idx) => (
                    <div
                        key={idx}
                        onClick={() => navigate(`/dashboard/news/${idx}`)}
                        className="bg-card rounded-lg overflow-hidden hover:shadow-lg transition-shadow cursor-pointer border border-border"
                    >
                        <img src={item.image_URL} alt={item.title} className="w-full h-40 object-cover" />
                        <div className="p-4 space-y-1">
                            <div className="text-xs font-semibold text-muted-foreground uppercase tracking-wider">
                                {formatNewsDate(item.date)}
                            </div>
                            <div className="text-sm font-semibold text-foreground line-clamp-2">{item.title}</div>
                        </div>
                    </div>
                ))}
            </div>
        </div>
    );
}
